import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

// Images

export default function data({
  model,
  deleteEvent,
  editEvent,
  shutdownEvent,
  startEvent,
}) {
  model = model ?? [];

  const Overall = ({ name, id, code, ip, status }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <div>
        <button code={"btnEdit" + id} onClick={() => editEvent(`${id}`)}
          style={{ border: 0, backgroundColor: 'transparent' }}>
          <ModeEditIcon />
          <MDBadge
            badgeContent="Sửa"
            color="success"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        <button
          style={{ border: 0, backgroundColor: 'transparent' }}
          code={"btnDelete" + id}
          onClick={() => {
            deleteEvent(`${id}`);
          }}
        >
          <DeleteIcon />
          <MDBadge
            badgeContent="Xóa"
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        <button
          style={{ border: 0, backgroundColor: 'transparent' }}
          code={"btnShutDownStart" + id}
          onClick={() => {
            if (status === "running") {
              shutdownEvent(`${id}`);
            } else {
              startEvent(`${id}`);
            }
          }}
        >
          {status === "running" ? (
            <PowerSettingsNewIcon />
          ) : (
            <PlayCircleFilledWhiteIcon />
          )}
          <MDBadge
            badgeContent={status === "running" ? "Tắt VPS" : "Khởi động"}
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
      </div>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          style={{ flexDirection: "column", display: "flex" }}
        >
          {name}
        </MDTypography>
        <MDTypography variant="caption">
          Trạng thái:{" "}
          {status === "running"
            ? "hoạt động"
            : status === "suspend"
              ? "Tạm ngưng"
              : "tắt"}
        </MDTypography>
        <br />
        <MDTypography variant="caption">{code}</MDTypography>
        <MDTypography variant="caption">IP: {ip}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const RowItem = ({ value }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography variant="caption">{value}</MDTypography>
    </MDBox>
  );

  const rows = [];

  model.forEach((item) => {
    rows.push({
      overall: (
        <Overall
          name={item.name}
          id={item.id}
          code={item.code}
          ip={item.ip}
          status={item.status}
        />
      ),
      description: <RowItem value={item.description} />,
      configuration: (
        <RowItem
          value={`${item.core} CPU - ${item.ram} GB - ${item.storage} GB`}
        />
      ),
    });
  });

  return {
    columns: [
      { Header: "Mục", accessor: "overall", width: "45%", align: "left" },
      { Header: "Mô tả", accessor: "description", align: "left" },
      { Header: "Cấu hình", accessor: "configuration", align: "left" },
    ],
    rows: rows,
  };
}
